export const COMMUNICATION_IMAGE_MAX_BYTES = 5 * 1024 * 1024
export const COMMUNICATION_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'] as const
export const COMMUNICATION_MOBILE_QUERY = '(max-width: 767px)'

export function isImageWidthPercent(value: unknown): value is number {
  return typeof value === 'number' && Number.isInteger(value) && value >= 10 && value <= 100
}

export function youtubeVideoId(value: string): string | null {
  if (!value || value.length > 2048) return null
  try {
    const url = new URL(value)
    if (url.protocol !== 'https:' || url.username || url.password || url.port) return null
    const host = url.hostname.toLowerCase()
    const parts = url.pathname.split('/').filter(Boolean)
    let id: string | null = null
    if (host === 'youtu.be' || host === 'www.youtu.be') id = parts.length === 1 ? parts[0] : null
    else if (['youtube.com', 'www.youtube.com', 'm.youtube.com', 'www.youtube-nocookie.com', 'youtube-nocookie.com'].includes(host)) {
      if (url.pathname === '/watch') id = url.searchParams.get('v')
      else if (parts.length === 2 && ['embed', 'shorts', 'live'].includes(parts[0])) id = parts[1]
    }
    return id && /^[A-Za-z0-9_-]{11}$/.test(id) ? id : null
  } catch {
    return null
  }
}

export function youtubeWatchUrl(value: string): string | null {
  const id = youtubeVideoId(value)
  return id ? `https://www.youtube.com/watch?v=${id}` : null
}

export function youtubeEmbedUrl(value: string): string | null {
  const id = youtubeVideoId(value)
  return id ? `https://www.youtube-nocookie.com/embed/${id}` : null
}
